export default __webpack_public_path__ + "static/media/2.4848f125.png";